import Vue from 'vue';
import { IHttpService, IHttpRequest } from '@/app-modules/http';
import { inject, injectable } from 'inversify';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { container } from '@/app-modules/_ioc';
import { IErrorService } from '@/app-modules/error/error-service-interface';
import { ConfigurationBase, ConfigurationKey, ITogglesService } from '@/app-modules/config';

@injectable()
class ErrorService extends ConfigurationBase implements IErrorService {
  private static errorService: ErrorService;

  constructor(@inject(SERVICE_IDENTIFIERS.IHttpService) private readonly httpService: IHttpService,
  @inject(SERVICE_IDENTIFIERS.ITogglesService) private readonly toggleService: ITogglesService) {
    super();
    this.registerApplicationErrorHandler();
    this.registerClickEventErrorHandler();
  }

  public static init() {
    if (!ErrorService.errorService) {
      ErrorService.errorService = container.get(SERVICE_IDENTIFIERS.IErrorService);
    }
  }

  public logError(error: Error, userData?: object): void {
    try {
      const requestPayload = this.getErrorRequestPayload(error, userData || {});
      const request: IHttpRequest = {
        Url: '/uierror',
        Payload: requestPayload
      };
      console.error(requestPayload.Message, requestPayload);
      this.httpService.post(request, true);
    }
    catch (error) {
      // swallow. We don't want to error out and fall over handling an error
      console.error(error);
    }
  }

  public logInfo(message: string, data?: any): void {
    try {
      const request: IHttpRequest = {
        Url: '/uierror/log',
        Payload: this.getLogRequestPayload(message, data)
      };
      this.httpService.post(request, true);
    }
    catch (err) {
      console.error(err);
    }
  }

  private getErrorRequestPayload(error: Error, userData?: object): { [key: string]: string | object } {
    const environment = this.getConfigurationItem(ConfigurationKey.CONFIG_ENV) || 'dev';
    return {
      Name: error.name,
      Message: error.message,
      Stack: error.stack || '',
      UserData: userData || {},
      Environment: environment
    };
  }

  private getLogRequestPayload(message: string, data?: any): { [key: string]: string | object } {
    const environment = this.getConfigurationItem(ConfigurationKey.CONFIG_ENV) || 'dev';
    return {
      message,
      data: {
        Message: message,
        UserData: data || {},
        Environment: environment
      }
    };
  }

  private registerApplicationErrorHandler(): void {
    Vue.config.errorHandler = (error, vm, info) => {
      this.logError(error, { info });
    };
  }

  private registerClickEventErrorHandler(): void {
    window.onerror = (message, source, lineNumber, columnNumber, errorObj) => {
      const error = errorObj || new Error(message as string);
      const userData = {
        Source: source || '',
        LineNumber: lineNumber || '',
        ColumnNumber: columnNumber || ''
      };
      this.logError(error, userData);
    };
  }
}

export default ErrorService;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/error/error-service.ts